import { io } from "socket.io-client";
import { url } from "./Constant";
export const socket = io(url);
